// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"13395542","513":"280f5cfb","703":"a791cd71","787":"50594cdd"}[chunkId] + ".chunk.js";
};